import React, { Component } from 'preact/compat';
import PropTypes from 'prop-types';

import getNewsArticles from './getNewsArticles';
import DEFAULT_FIELD from '../../lib/defaultArticleField';

export default (ComponentWithData) => {
  class WithData extends Component {
    state = { newsArticles: [] };

    async componentWillMount() {
      const {
        field,
        keywords,
        setKeywords,
        featured,
        limit,
        offset,
        notInIds,
        setNotInIds,
        inDays,
        sort,
        inIds,
        categoryIds,
        inCreatedByIds,
      } = this.props;

      const variables = {
        keywords: [...keywords, ...setKeywords],
        notInIds: [...notInIds, ...setNotInIds],
        featured,
        limit,
        offset,
        inDays,
        sort,
        inIds,
        categoryIds,
        inCreatedByIds,
      };

      this.setState({
        newsArticles: await getNewsArticles(variables, field),
      });
    }

    render() {
      return (
        <ComponentWithData {...this.state} {...this.props} />
      );
    }
  }

  WithData.propTypes = {
    field: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string),
    setKeywords: PropTypes.arrayOf(PropTypes.string),
    notInIds: PropTypes.arrayOf(PropTypes.number),
    setNotInIds: PropTypes.arrayOf(PropTypes.number),
  };

  WithData.defaultProps = {
    field: DEFAULT_FIELD,
    keywords: [],
    setKeywords: [],
    notInIds: [],
    setNotInIds: [],
  };

  return WithData;
};
